import { useContext, useEffect } from "react";
import { ChatContext } from "./ChatContext";

const ChatContextSetter = ({ context }) => {
  const { setCurrentContext } = useContext(ChatContext);
  useEffect(() => {
    setCurrentContext(context);
    return () => {
      setCurrentContext(null);
    };
  }, [context, setCurrentContext]);
  return null;
};

export default ChatContextSetter;
